// AIContentRefContext.tsx
import { createContext, useContext } from "react";

export const AIContentRefContext = createContext<{
  registerRef: (ref: HTMLDivElement) => void;
  unregisterRef: (ref: HTMLDivElement) => void;
}>({
  registerRef: () => {},
  unregisterRef: () => {},
});

export const useAIContentRefContext = () => useContext(AIContentRefContext);
